import { useEffect, useState } from "react";
import { Box, Typography, CircularProgress, IconButton } from "@mui/material";
import * as turf from "@turf/turf";
import {
  CircularInput,
  CircularThumb,
  CircularTrack,
} from "react-circular-input";
import { TooltipCustom } from "../../ui/tooltip-custom";

// svg
import { ReactComponent as IconRefresh } from "../../../assets/svg/refresh-cw.svg";
import { ReactComponent as IconRotateLeft } from "../../../assets/svg/rotate-ccw.svg";
import { ReactComponent as IconRotateRight } from "../../../assets/svg/rotate-cw.svg";
import { ReactComponent as IconMove } from "../../../assets/svg/move.svg";
import { ReactComponent as IconRotate } from "../../../assets/svg/refresh-2.5.svg";

export const StepRotate = ({
  /* geoJSON, */
  /* pivot,
  bearing,
  angle, */
  /* updatePropertyData,
  uploadedPropertyGeoJSON */
}) => {
  /* const applyRotation = (deg) => {
    if (!geoJSON || !pivot) return;
    updatePropertyData("bearing", deg);
    updatePropertyData("angle", deg);
  }; */

 /*  useEffect(() => {
    if (geoJSON) {
      updatePropertyData("uploadedPropertyGeoJSON", uploadedPropertyGeoJSON);
    }
  }, [geoJSON]); */

  return (
    <>
      <Box>
        {/* <Typography variant="body1" sx={{ px: 2, pt: "12px", fontSize: '14px' }}>
        Click-&-drag inside the shape to adjust polygon’s position. 
        Drag a corner handle or use the circular slider below to adjust polygon’s orientation. 
        Moves and rotations save instantly.
        </Typography> */}

        <Typography variant="body1" sx={{ fontSize: "14px", color: "#777982" }}>
          You can adjust your site’s position and orientation in two ways:
        </Typography>

        <Typography
          variant="body1"
          sx={{ pt: "12px", fontSize: "14px", color: "#777982" }}
        >
          <IconMove
            stroke="#777982"
            width={"18px"}
            height={"18px"}
            style={{ marginBottom: "4px", verticalAlign: "middle", marginRight: '8px' }}
          />
          <strong>Move:</strong> click and drag anywhere inside the shape to pan
          it around.
        </Typography>

        <Typography
          variant="body1"
          sx={{ pt: "12px", fontSize: "14px", color: "#777982" }}
        >
          <IconRotate
            stroke="#777982"
            strokeWidth={2.5}
            width={"16px"}
            height={"16px"}
            style={{ marginBottom: "4px", verticalAlign: "middle", marginRight: '8px' }}
          />
          <strong>Rotate:</strong> grab one of the four corner handles and drag
          to spin the shape around its center.
        </Typography>
        <Typography
          variant="body1"
          sx={{ pt: "12px", fontSize: "14px", color: "#777982" }}
        >
          Both move and rotate changes update the feature immediately and are
          saved automatically.
        </Typography>
      </Box>
      {/* <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "160px",
          }}
        >
          <CircularInput
            value={angle / 360}
            onChange={(v) => applyRotation(v * 360)}
            radius={60}
          >
            <CircularTrack stroke="#5E6278" strokeWidth={16} />
            <CircularProgress stroke="#1d1e26" strokeWidth={25} />
            <CircularThumb fill="#efa21e" r={12} />
            <text
              x={60}
              y={67}
              textAnchor="middle"
              fontWeight="bold"
            >
              {angle.toFixed(1)}°
            </text>
          </CircularInput>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            my: 1,
          }}
        >
          <TooltipCustom text={"Rotate -1°"} placement="top">
            <IconButton size="small" onClick={() => applyRotation(bearing - 1)}>
              <IconRotateLeft fontSize="small" />
            </IconButton>
          </TooltipCustom>
          <TooltipCustom text={"Reset rotation"} placement="top">
            <IconButton size="small" onClick={() => applyRotation(0)}>
              <IconRefresh />
            </IconButton>
          </TooltipCustom>

          <TooltipCustom text={"Rotate +1°"} placement="top">
            <IconButton size="small" onClick={() => applyRotation(bearing + 1)}>
              <IconRotateRight fontSize="small" />
            </IconButton>
          </TooltipCustom>
        </Box>
      </Box> */}
    </>
  );
};
